module.exports = __webpack_public_path__ + "static/media/brand.022c3680.svg";